import { CompanyProfileDto } from 'components/intermediaryApplications/intermediaryApplications.dto';

import { AccountStatus as AccountStatusEnum, SectionStatus, StatusSectionName } from './accountStatus.enums';

export const getSectionStatus = (name: StatusSectionName, companyProfile: CompanyProfileDto | null) => {
  if (!companyProfile) {
    return SectionStatus.Incomplete;
  }

  switch (name) {
    case StatusSectionName.ContractorRegistration:
      return companyProfile?.isFullRegistrationCompleted ? SectionStatus.Complete : SectionStatus.Active;

    case StatusSectionName.MasterDealerAgreement:
      if (companyProfile?.masterDealerAgreementWasSigned) {
        return SectionStatus.Complete;
      }

      if (companyProfile?.isFullRegistrationCompleted) {
        return SectionStatus.Active;
      }

      break;

    case StatusSectionName.IntakeMeeting:
      if (companyProfile?.isIntakeMeetingCompleted) {
        return SectionStatus.Complete;
      }

      if (companyProfile?.masterDealerAgreementWasSigned && companyProfile?.isFullRegistrationCompleted) {
        return SectionStatus.Active;
      }

      break;
  }

  return SectionStatus.Incomplete;
};

export const getAccountHeaderStatus = (companyProfile: CompanyProfileDto | null) => {
  if (!companyProfile) {
    return AccountStatusEnum.ContractorInformationNeeded;
  }

  if (!companyProfile?.isFullRegistrationCompleted) {
    return AccountStatusEnum.ContractorInformationNeeded;
  }

  if (!companyProfile?.masterDealerAgreementWasSigned) {
    return AccountStatusEnum.MdaNeeded;
  }

  if (!companyProfile?.isIntakeMeetingCompleted) {
    return AccountStatusEnum.IntakeNeeded;
  }

  return AccountStatusEnum.Complete;
};
